import { usePaymentMethodStore } from '../payment';

export function useSelectedGiftCard() {
  const selectedPaymentMethod = usePaymentMethodStore(state => state.selectedPaymentMethod);
  const userAccountsData = usePaymentMethodStore(state => state.userAccountsData);

  if (selectedPaymentMethod !== 'giftCard') {
    return null;
  }

  const selectedGiftCard = userAccountsData.userAccounts?.accounts?.find(
    account => account?.giftCard
  )?.giftCard;

  return selectedGiftCard;
}
